"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @deprecated It is better to set your script at the end of the page to have a more native feel for end of loading state.
 *  By using this function or any other function you risk waiting on images frames and videos to be loaded as well.
 *
 * @param fn
 */
var ready = function (fn) {
    if (document.readyState !== 'loading') {
        if (fn instanceof Function) {
            fn(null);
        }
    }
    else {
        document.addEventListener('DOMContentLoaded', fn);
    }
};
exports.default = ready;
//# sourceMappingURL=full-ready.js.map